<div class="points-help-dialog">
  <h2 mat-dialog-title>
    <mat-icon>help_outline</mat-icon>
    Points &amp; Balles : comment ça marche ?
  </h2>
  
  <mat-dialog-content>
    <div class="help-section">
      <h3>
        <mat-icon>sports_soccer</mat-icon>
        Deux monnaies différentes
      </h3>
      <div class="point-type">
        <div class="point-header">
          <mat-icon class="score-icon">emoji_events</mat-icon>
          <strong>Points (classement)</strong>
        </div>
        <p>Déterminent votre position dans le classement. Vous ne pouvez pas les dépenser.</p>
      </div>
      
      <div class="point-type">
        <div class="point-header">
          <mat-icon class="solde-icon">sports_soccer</mat-icon>
          <strong>Balles ⚽ (monnaie)</strong>
        </div>
        <p>Servent à acheter des power-ups pour améliorer vos pronostics. Dépensez-les, elles sont faites pour ça !</p>
      </div>
    </div>

    <mat-divider></mat-divider>

    <div class="help-section">
      <h3>
        <mat-icon>add_circle</mat-icon>
        Comment gagner des balles ?
      </h3>
      <ul class="points-list">
        <li>
          <mat-icon>check_circle</mat-icon>
          <div>
            <strong>Pronostics incorrects</strong>
            <p>Quand vous vous trompez, vous gagnez l'équivalent en balles au lieu des points de classement. Plus le choix était risqué, plus vous gagnez de balles !</p>
          </div>
        </li>
      </ul>
    </div>

    <mat-divider></mat-divider>

    <div class="help-section">
      <h3>
        <mat-icon>shopping_cart</mat-icon>
        Comment dépenser vos balles ?
      </h3>
      <ul class="points-list">
        <li>
          <mat-icon>visibility</mat-icon>
          <div>
            <strong>Espion (60 ⚽)</strong>
            <p>Voir les stats de réponses des autres joueurs avant la deadline. Max 1/pari</p>
          </div>
        </li>
        <li>
          <mat-icon>content_copy</mat-icon>
          <div>
            <strong>Double Réponse (75 ⚽)</strong>
            <p>Choisissez 2 options pour un pronostic. Max 1/pari, 3/journée</p>
          </div>
        </li>
        <li>
          <mat-icon>schedule</mat-icon>
          <div>
            <strong>Changement Tardif (85 ⚽)</strong>
            <p>À acheter avant la deadline. Modifiez votre choix jusqu'à 15 min après. Max 1/pari</p>
          </div>
        </li>
        <li>
          <mat-icon>close</mat-icon>
          <div>
            <strong>Multiplicateur ×2 (100 ⚽)</strong>
            <p>Double les points gagnés sur ce pronostic. Max 1/pari, 3/journée</p>
          </div>
        </li>
        <li>
          <mat-icon>swap_horiz</mat-icon>
          <div>
            <strong>Conversion Balles → Score</strong>
            <p>Convertissez vos balles en points de classement (taux 10:1)</p>
          </div>
        </li>
      </ul>
    </div>

    <mat-divider></mat-divider>

    <div class="help-section tip-section">
      <h3>
        <mat-icon>lightbulb</mat-icon>
        Conseils stratégiques
      </h3>
      <ul class="tips-list">
        <li>
          <mat-icon>trending_up</mat-icon>
          Utilisez le Double Réponse sur les matchs incertains
        </li>
        <li>
          <mat-icon>timer</mat-icon>
          Le Changement Tardif est utile en cas de blessure de dernière minute
        </li>
        <li>
          <mat-icon>star</mat-icon>
          Le Multiplicateur est rentable quand vous êtes confiant sur un prono
        </li>
        <li>
          <mat-icon>warning</mat-icon>
          La conversion Balles → Score a un taux désavantageux (10:1), utilisez-la en dernier recours
        </li>
      </ul>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="close()">
      <mat-icon>check</mat-icon>
      J'ai compris
    </button>
  </mat-dialog-actions>
</div>
